"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WEIGHT_SPECIFICITIES_UUID = exports.MIN_ITEMS_TO_USE_AUTOCOMPLETE_INSTEAD_OF_SELECT = exports.BASE_URL = exports.BASE_API_URL = void 0;
var _Utils = require("react-platform-components/dist/Utils");
var BASE_API_URL = (0, _Utils.getBackendConfig)('REACT_BASE_API_URL', process.env.REACT_APP_BASE_API_URL);
exports.BASE_API_URL = BASE_API_URL;
var BASE_URL = (0, _Utils.getBackendConfig)("REACT_BASE_URL", process.env.REACT_APP_BASE_URL);
exports.BASE_URL = BASE_URL;
var WEIGHT_SPECIFICITIES_UUID;
exports.WEIGHT_SPECIFICITIES_UUID = WEIGHT_SPECIFICITIES_UUID;
try {
  exports.WEIGHT_SPECIFICITIES_UUID = WEIGHT_SPECIFICITIES_UUID = require('react-platform-shipping/dist/config').WEIGHT_SPECIFICITY_UUID;
} catch (error) {}
var MIN_ITEMS_TO_USE_AUTOCOMPLETE_INSTEAD_OF_SELECT = Number(process.env.REACT_APP_MIN_ITEMS_TO_USE_AUTOCOMPLETE_INSTEAD_OF_SELECT || Infinity);
exports.MIN_ITEMS_TO_USE_AUTOCOMPLETE_INSTEAD_OF_SELECT = MIN_ITEMS_TO_USE_AUTOCOMPLETE_INSTEAD_OF_SELECT;